<template>
  <div class="modal-card">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <header class="modal-card-head">
      <p class="modal-card-title">Generar reporte</p>
    </header>
    <section class="modal-card-body" v-if="!isLoading">
      <div class="columns">
        <div class="column is-4">
          <b-field label="Fecha de inicio">
            <b-datepicker
              placeholder="Haga click para seleccionar..."
              icon="calendar-today"
              trap-focus
              v-model="dateStart"
              append-to-body
              :first-day-of-week="1"
              :day-names="daysOfTheWeek"
              :month-names="monthNames"
            ></b-datepicker>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field label="Fecha de término">
            <b-datepicker
              placeholder="Haga click para seleccionar..."
              icon="calendar-today"
              trap-focus
              nearby-month-days
              v-model="dateEnd"
              append-to-body
              :first-day-of-week="1"
              :day-names="daysOfTheWeek"
              :month-names="monthNames"
            ></b-datepicker>
          </b-field>
        </div>
        <div class="column is-4">
          <b-tooltip label="Seleccione un rango de fechas"
              position="is-bottom"
              type="is-light"
              :active="dates.length === 0"
              >
            <b-button icon-left="download" :disabled="dates.length === 0" style="margin-top:2em" class="button is-primary" type="button" @click="generateReport">Descargar reporte</b-button>
          </b-tooltip>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">Cerrar</button>
    </footer>
  </div>
</template>

<script>

import moment from "moment";
import { DocumentService } from '../../services/models/document';
export default {
  props: ["dateLabel", "cellar_id", "serviceReport"],
  data() {
    return {
      dates: [1],
      dateStart: new Date(),
      dateEnd: new Date(),
      daysOfTheWeek: ["D","L","M","M","J","V","S"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      isComponentModalActive: false,
      isLoading: false,
      patient: {},
    };
  },
  mounted() {
    console.log('mounted');
  },
  methods: {
    // startRange(e) {
    //   let selectedDateMin = moment(e).subtract(10, 'day');
    //   let selectedDateMax = moment(e).add(10, 'day');
    //   this.minDate = new Date(selectedDateMin);
    //   if (selectedDateMax.isSameOrAfter(moment(new Date()))) {
    //     this.maxDate = new Date();
    //   } else {
    //     this.maxDate = new Date(selectedDateMax);
    //   }
    // },
    // endRange() {
    //   this.minDate = new Date(moment('2020-03-01'));
    //   this.maxDate = new Date();
    // },
    async generateReport() {
      let loader = this.$buefy.loading.open();
      // let minDate = moment(this.minDate).format("YYYY-MM-DD") + " 00:00:00";
      let minDate = moment(this.dateStart).format("YYYY-MM-DD");
      // let maxDate = moment(this.maxDate).format("YYYY-MM-DD") + " 23:59:59";
      let maxDate = moment(this.dateEnd).format("YYYY-MM-DD");
      // let excelResponse = await this.serviceReport(minDate, maxDate, this.cellar_id);
      let excelResponse = await DocumentService.downloadReport(minDate, maxDate, this.cellar_id);
      console.log(excelResponse);
      var a = document.createElement('a');
      var url = window.URL.createObjectURL(excelResponse.data);
      a.href = url;
      a.download = `REPORTE_${moment(this.dateStart).format("DD-MM-YYYY")}_${moment(this.dateEnd).format("DD-MM-YYYY")}.xlsx`;
      document.body.append(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      loader.close();
    }
  },
};
</script>
